import { IoMdClose } from "react-icons/io";
import * as Yup from "yup";
import { routes } from "routes/apiRoutes";
import makeRequest from "services/makeRequest";
import { Formik, Form, ErrorMessage } from "formik";
import { emailValidation, phoneNumberValidation } from "utils/validators";
import { Modal, Typography, Button, TextField, FormError } from "components";
import { formatPhoneNumber, setAlert, isSuccessResponse } from "utils/helper";

const EditUserModal = ({ userInfo, isModalVisible, setIsModalVisible }) => {
  const { email, phoneNumber } = userInfo;

  const validationSchema = Yup.object({
    email: emailValidation(),
    phoneNumber: phoneNumberValidation("Phone Number", "phoneNumber", false),
  });

  const updateAgentDetails = async (payload) => {
    const formattedPhoneNumber = formatPhoneNumber(payload.phoneNumber);
    const newPayload = {
      phoneNumber: formattedPhoneNumber,
      email: payload.email,
    };

    try {
      const { data } = await makeRequest(
        "put",
        routes.userUpdate(userInfo.id),
        newPayload
      );

      if (isSuccessResponse(data)) {
        setAlert("Agent update request submitted for approval", "success");
        setIsModalVisible(false);
      } else {
        setAlert(data.responseMessage, "error");
      }
    } catch (err) {}
  };

  return (
    <Modal
      showModal={isModalVisible}
      customPadding={"0"}
      onClose={() => setIsModalVisible(false)}
    >
      <div className="add-account-modal">
        <div className="header">
          <div className="d-flex justify-content-end ">
            <IoMdClose
              className="cursor-pointer"
              onClick={() => setIsModalVisible(false)}
            />
          </div>
          <Typography variant="body0" state="primary" className={"text-center"}>
            Edit Details
          </Typography>
          <Typography variant="caption0" className="text-center">
            Edit Profile Information below
          </Typography>
        </div>
        <div className="body p-4">
          <Formik
            initialValues={{
              email,
              phoneNumber: phoneNumber?.replace(/234/i, "0"),
            }}
            validationSchema={validationSchema}
            onSubmit={updateAgentDetails}
          >
            {({
              errors,
              touched,
              isSubmitting,
              values,
              setFieldValue,
              getFieldProps,
            }) => (
              <Form noValidate autoComplete="off">
                <div className="mb-3">
                  <TextField
                    name="email"
                    type="text"
                    placeholder="Enter email"
                    label="Email Address"
                    {...getFieldProps("email")}
                    hasError={errors.email && touched.email}
                  />
                  <ErrorMessage component={FormError} name="email" />
                </div>
                <div>
                  <TextField
                    name="phoneNumber"
                    type="tel"
                    placeholder="Enter Phone Number"
                    label="Phone Number"
                    pattern="[0-9]*"
                    {...getFieldProps("phoneNumber")}
                    hasError={errors.phoneNumber && touched.phoneNumber}
                  />
                  <ErrorMessage component={FormError} name="phoneNumber" />
                </div>
                <div
                  className="footer d-flex justify-content-center align-items-center pb-4"
                  style={{ marginTop: "3rem" }}
                >
                  <Button
                    label="Cancel"
                    variant="secondary"
                    size="sm"
                    onClick={() => setIsModalVisible(false)}
                  />{" "}
                  &nbsp; &nbsp;
                  <Button
                    label="Submit for Approval"
                    size="sm"
                    loading={isSubmitting}
                    type="submit"
                    style={{ width: "12rem" }}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </Modal>
  );
};

export default EditUserModal;
